import React, { useEffect, useState } from "react";
import Logo from "../../../Images/logo192.png";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getContractById,
  updateContract,
} from "../../../redux/contractSlice/contractSlice";
import notify from "../../../hooks/useNotifaction";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  formatDateArabic,
  formatDateNumbers,
} from "../../../utils/dateFormatter";

export default function Contract({
  contract = {},
  selectedCompany,
  selectedBranch,
}) {
  const location = useLocation();
  const { ContractId } = useParams();
  const isContractPage =
    location.pathname === `/Contracts/Contract/${ContractId}`;
  const isContractAddPage = location.pathname === `/addContract`;
  const dispatch = useDispatch();
  const { detailsContract } = useSelector((state) => state.contract);

  const [contractDetails, setContractDetails] = useState(null);
  const [editedInstallments, setEditedInstallments] = useState([]);
  const [isOffer, setIsOffer] = useState(false);

  useEffect(() => {
    if (isContractPage) dispatch(getContractById(ContractId));
  }, [dispatch, isContractPage, ContractId]);

  useEffect(() => {
    if (detailsContract && isContractPage) {
      console.log(detailsContract);
      setContractDetails(detailsContract);
    } else {
      console.log(contract);
      setContractDetails(contract);
    }
  }, [detailsContract, contract]);

  const handleUpdate = async () => {
    if (!editedInstallments.length) {
      notify("لا توجد بيانات لتحديثها.", "info");
      return;
    }

    const installmentUpdates = [];
    const statusUpdates = [];
    let dueDateUpdate = null;

    editedInstallments.forEach((inst) => {
      const original =
        contractDetails.payment_installments[inst.installment_number - 1];
      const amountChanged = inst.amount !== original.amount;
      const statusChanged = inst.status !== original.status;
      const dateChanged = inst.due_date && inst.due_date !== original.due_date;

      if (amountChanged)
        installmentUpdates.push({
          installment_number: inst.installment_number,
          amount: inst.amount,
        });
      if (statusChanged)
        statusUpdates.push({
          installment_number: inst.installment_number,
          status: inst.status,
        });
      if (dateChanged)
        dueDateUpdate = {
          installment_number: inst.installment_number,
          due_date: inst.due_date,
        };
    });

    const dataPayload = {
      value: Number(contractDetails.value),
      installment_count: contractDetails.payment_installments.length,
    };

    if (installmentUpdates.length)
      dataPayload.installments_update = installmentUpdates;
    if (statusUpdates.length === 1)
      dataPayload.payment_status_update = statusUpdates[0];
    if (dueDateUpdate) dataPayload.due_date_update = dueDateUpdate;

    try {
      await dispatch(
        updateContract({ id: ContractId, data: dataPayload })
      ).unwrap();
      const updated = await dispatch(getContractById(ContractId)).unwrap();
      setContractDetails({ ...updated });
      setEditedInstallments([]);
      notify("تم حفظ التعديلات بنجاح", "success");
    } catch (err) {
      notify(err.message, "error");
    }
  };

  const handlePrintContract = () => {
    document.body.classList.remove("offer-print");
    setTimeout(() => window.print(), 100);
  };

  const handlePrintOffer = () => {
    const titleContract = document.querySelector(".title-contract");
    const pageTitle = document.querySelector(".page-title");
    const introLine = document.querySelector(".intro-line");

    const originalTitle = titleContract?.textContent;
    const originalPageTitle = pageTitle?.textContent;

    if (titleContract) titleContract.textContent = "عرض سعر";
    if (pageTitle) pageTitle.textContent = "عرض سعر";
    if (introLine) introLine.style.display = "none";

    setTimeout(() => {
      window.print();

      if (titleContract) titleContract.textContent = originalTitle;
      if (pageTitle) pageTitle.textContent = originalPageTitle;
      if (introLine) introLine.style.display = "";
    }, 100);
  };

  const filteredTerms =
    contractDetails?.terms?.filter((term) => term.title !== "main") || [];
  const mainTerms =
    contractDetails?.terms?.filter((term) => term.title === "main") || [];

  return (
    <>
      {/* -------- HEADER FOR PRINT -------- */}
      <div className="print-header d-none d-print-block text-center py-3 mb-3 w-100">
        <div className="logo-print d-flex mb-2 align-items-center justify-content-between">
          <div>
            <h1 className="h6 mb-0 text-center">
              بصمة خبرة لأدوات الأمن والسلامة
            </h1>
            <h1 className="h6 mb-0 text-start">
              Experience Mark For Safety & Security Tools
            </h1>
            <p className="mb-0">
              Supply ,Installation & Maintenance توريد وتركيب وصيانة
            </p>
          </div>
          <figure className="me-5 mb-0 ">
            <img src={Logo} alt="logo" />
          </figure>
        </div>
      </div>

      <div className={isContractPage ? "main" : "container-fluid"}>
        <h1 className="mb-3 text-white print-hide page-title">
          عقد شركة أرامكو للبترول
        </h1>
        <div className="container22">
          <div className="card">
            {isContractPage && (
              <div className="card-header text-end print-hide">
                <button
                  className="btn btn-primary me-2"
                  onClick={handlePrintContract}
                >
                  طباعة عقد
                </button>
                <button className="btn btn-success" onClick={handlePrintOffer}>
                  طباعة عرض سعر
                </button>
              </div>
            )}

            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-12">
                  <div className="print-   py-3 mb-2 d-print-none">
                    <div className="logo d-flex mb-3 align-items-center ">
                      <figure className="me-3 mb-0">
                        <img src={Logo} alt="logo" style={{ height: "70px" }} />
                      </figure>
                      <div>
                        <h1 className="h6 mb-0 text-start">
                          بصمة خبرة لأدوات الأمن والسلامة
                        </h1>
                        <h1 className="h6 mb-0 text-start">
                          Experience Mark For Safety & Security Tools
                        </h1>
                        <p className="mb-0 fs-5 text-start" dir="ltr">
                          Supply ,Installation & Maintenance توريد وتركيب وصيانة
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4  mx-auto text-center">
                  <h4 className="title-contract contract-type-title">
                    عقد صيانة
                  </h4>
                  <h5>{contractDetails?.contract_number}</h5>
                </div>
              </div>

              <div className="">
                <p className="intro-line">
                  تم بعون الله وتوفيقه إبرام هذا {isOffer ? "العرض" : "العقد"}{" "}
                  في {formatDateNumbers(contractDetails?.start_date)} بين كلا من
                  :-
                </p>

                <div className="d-flex justify-content-between">
                  <p>
                    {contractDetails?.name ||
                      `شركة ${
                        selectedCompany?.label ||
                        contractDetails?.branch?.company?.name
                      } فرع ${
                        selectedBranch?.label || contractDetails?.branch?.name
                      }`}
                  </p>
                  {contractDetails?.first_party && (
                    <p>ويمثله {contractDetails?.first_party}</p>
                  )}
                  <p>(يشار اليها فيما يلي بالطرف الأول)</p>
                </div>
                <div className="d-flex justify-content-between">
                  <p>مؤسسة بصمة خبرة لأدوات ومواد السلامة</p>
                  {contractDetails?.second_party && (
                    <p className="personInfo">
                      ويمثله {contractDetails?.second_party}
                    </p>
                  )}
                  <p>(يشار اليها فيما يلي بالطرف الثاني)</p>
                </div>
              </div>

              <div className="">
                <h5>تمهيد</h5>
                <p>{contractDetails?.introduction || "لا يوجد تمهيد."}</p>
              </div>

              {contractDetails?.clauses?.length > 0 && (
                <>
                  <div
                    className="mx-5 col-md-4 col-sm-6 mt-5"
                    style={{ marginTop: "30px" }}
                  >
                    <h5>مفردات الصيانة :</h5>
                  </div>
                  <table className="table table-bordered text-center">
                    <thead>
                      <tr>
                        <th>م</th>
                        <th>البند</th>
                        {contractDetails?.clauses.some(
                          (clause) => clause.quantity !== undefined
                        ) && <th>الكمية</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {contractDetails?.clauses.length > 0 ? (
                        contractDetails?.clauses.map((clause, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td className="text-start">{clause.item}</td>
                            {contractDetails?.clauses.some(
                              (c) => c.quantity !== undefined
                            ) && (
                              <td className="text-start">
                                {clause?.quantity || "-"}
                              </td>
                            )}
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={
                              contractDetails?.clauses.some(
                                (c) => c.quantity !== undefined
                              )
                                ? "3"
                                : "2"
                            }
                          >
                            لا توجد بنود حالياً.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>
              )}

              <div className="row justify-content-between ">
                <div className="col-md-4 col-sm-6">
                  <h5>المدة:</h5>
                  <p>
                    {formatDateNumbers(contractDetails?.start_date)} حتى{" "}
                    {formatDateNumbers(contractDetails?.end_date)}
                  </p>
                </div>
                <div className="col-md-4 col-sm-6">
                  <h5>القيمة:</h5>
                  <p>{contractDetails?.value} ريال سعودي</p>
                </div>
                <div className="col-md-4 col-sm-6">
                  <h5>عدد الزيارات:</h5>
                  <p>{contractDetails?.maintenance_visits} زيارة</p>
                </div>
                <div className="col-md-4 col-sm-6">
                  <h5>طريقة الدفع:</h5>
                  <p>
                    {contractDetails?.payment_type === "full"
                      ? "نقدي"
                      : "دفعات"}
                  </p>
                </div>
              </div>

              {contractDetails?.payment_type === "installments" &&
                !isContractAddPage &&
                !isOffer && (
                  <>
                    <div className="mx-5 col-md-4 col-sm-6 mt-5 print-hide">
                      <h5>دفعات التقسيط:</h5>
                    </div>
                    <table className="table table-bordered text-center align-middle print-hide">
                      <thead>
                        <tr>
                          <th>م</th>
                          <th>المبلغ (ر.س)</th>
                          <th>تاريخ الاستحقاق</th>
                          <th>حالة الدفع</th>
                        </tr>
                      </thead>
                      <tbody>
                        {contractDetails.payment_installments?.length > 0 ? (
                          contractDetails.payment_installments.map(
                            (installment, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{installment.amount}</td>
                                <td>{installment.due_date}</td>
                                <td>
                                  {installment.status === "paid"
                                    ? "مدفوع"
                                    : "غير مدفوع"}
                                </td>
                              </tr>
                            )
                          )
                        ) : (
                          <tr>
                            <td colSpan="4">لا توجد دفعات حالياً.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </>
                )}

              {contractDetails?.terms?.length > 0 && (
                <div>
                  <h5>بنود العقد:</h5>
                  <ol>
                    {contractDetails?.terms?.length > 0 ? (
                      contractDetails?.terms?.map((term, index) => (
                        <li key={index}>
                          <p>{term.description}</p>
                        </li>
                      ))
                    ) : (
                      <p>لا توجد بنود حالياً.</p>
                    )}
                  </ol>
                </div>
              )}

              <div className="signature-section">
                <div className="row">
                  <div className="col-6 text-center">
                    <p className="h5">الطرف الأول</p>
                    <p className="">
                      {" "}
                      {contractDetails?.name ||
                        `شركة ${
                          selectedCompany?.label ||
                          contractDetails?.branch?.company?.name
                        } `}{" "}
                    </p>
                    <p>التوقيع</p>
                    <p>الختم</p>
                  </div>
                  <div className="col-6 text-center">
                    <p className="h5">الطرف الثاني</p>
                    <p>شركة بصمة خبرة</p>
                    <p>التوقيع</p>
                    <p>الختم</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -------- FIXED FOOTER FOR EVERY PAGE -------- */}
      <div className="print-footer-fixed d-none d-print-block">
        <div className="footer-content">
          <div className="footer-top text-white">
            <span className="text-white">
              المركز الرئيسي: جدة - فرع الرياض - فرع الدمام
            </span>
          </div>
          <div className="footer-bottom">
            <div className="footer-item">
              <i className="fa fa-phone"></i> 0531955966
            </div>
            <div className="footer-item">
              <i className="fa fa-phone"></i> 0541344107
            </div>
            <div className="footer-item">
              <i className="fa fa-envelope"></i> ali@experience-mark.com
            </div>
            <div className="footer-item">
              <i className="fa fa-globe"></i> www.experiencemark.com
            </div>
          </div>
        </div>
      </div>

      {/* -------- PRINT CSS -------- */}
      <style>
        {`
  @media print {
    @page {
      margin: 0;
      size: A4;
    }

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    html, body {
      margin: 0 !important;
      padding: 0 !important;
      height: 100% !important;
      overflow: visible !important;
    }

    body {
      padding-top: 0 !important;
      padding-bottom: 100px !important;
    }

    header, footer {
      display: none !important;
    }

    .print-hide {
      display: none !important;
    }

    /* الهيدر المطبوع */
    .print-header {
      display: block !important;
      margin: 0 !important;
      padding: 15px 20px !important;
      border-bottom: 2px solid #0097a7;
      background: white;
    }

    .print-header .logo-print img {
      max-width: 80px;
      height: auto;
    }

    /* المحتوى */
    .main, .container-fluid {
      margin: 0 !important;
      padding: 20px !important;
    }

    .card {
      border: none !important;
      box-shadow: none !important;
    }

    .card-body {
      padding: 20px !important;
    }

    /* الجداول */
    table {
      page-break-inside: auto !important;
      margin-bottom: 20px !important;
    }

    tr {
      break-inside: auto !important;
      page-break-inside: auto !important;
    }

    td, th {
      break-inside: avoid !important;
      page-break-inside: avoid !important;
      padding: 8px !important;
    }

    thead {
      display: table-header-group !important;
    }

    tbody {
      page-break-inside: auto !important;
    }

    /* قسم التوقيعات */
    .signature-section {
      page-break-inside: avoid !important;
      margin-top: 30px !important;
    }

    /* الفوتر الثابت في كل صفحة */
    .print-footer-fixed {
      display: block !important;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 80px;
      background: linear-gradient(to right, #0097a7, #00796b) !important;
      color: white !important;
      font-size: 11px;
      z-index: 9999;
    }

    .footer-content {
      padding: 8px 20px;
    }

    .footer-top {
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      margin-bottom: 6px;
      border-bottom: 1px solid rgba(255,255,255,0.3);
      padding-bottom: 4px;
    }

    .footer-bottom {
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 10px;
      font-size: 10px;
    }

    .footer-item {
      display: flex;
      align-items: center;
      gap: 5px;
      color: white !important;
    }

    .footer-item i {
      font-size: 11px;
    }

    body::before,
    body::after {
      display: none !important;
    }
  }

  .print-header {
    display: none;
  }

  .print-footer-fixed {
    display: none;
  }
`}
      </style>
    </>
  );
}
